<snelstart-ui-button (click)="this.showDialog()"
                     [disabled]="isPartner ? ((incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(indexOnderneming)?.eigenVermogen?.at(1)?.waardeSlot ?? null) === null : ((incomeTaxEntity$ | async)?.aangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(indexOnderneming)?.eigenVermogen?.at(1)?.waardeSlot ?? null) === null"
                     class="custom-input-150"
                     icon="plus"
                     type="secondary">Specificeer
</snelstart-ui-button>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="lg" size="xl" title="Specificatie egalisatiereserve">
  <snelstart-ui-dialog-header-content>
    Klik op '+ Dotatie specificatie toevoegen' en vul de dotatie aan de reserve in {{ (incomeTaxEntity$ | async)?.year}} in.
  </snelstart-ui-dialog-header-content>
  <snelstart-ui-dialog-body>
    <div style="display: flex; gap: 2rem; align-items: flex-start;">
      <div class="dialog-left" style="flex: 1 1 0; min-width: 0;">
        <form [formGroup]="omschrijvingBedragFg">
          <div formArrayName="omschrijvingBedrag">
            @for (item of omschrijvingBedrag.controls; track item; let i = $index) {
              <div [formGroupName]="i">
                <div class="row mb-1">
                  <div class="col-auto">
                    <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving dotatie' : ''"
                                                  class="custom-input-250"
                                                  formControlName="omschrijving"
                                                  id="omschrijving-' + i"
                    >
                    </snelstart-ui-text-form-control>
                  </div>
                  <div class="col-auto">
                    <snelstart-ui-number-form-control [label]="i === 0 ? 'Bedrag' : ''"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="bedrag"
                                                  id="bedrag-' + i"
                                                  prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-auto">
                    <snelstart-ui-button
                      (click)="verwijderRij(i)"
                      [class]="i === 0 ? 'firstrowbutton' : ''"
                      icon="trash"
                      iconType="light"
                      id="buttonDelete-' + i"
                      size="medium"
                      type="secondary"
                    >
                    </snelstart-ui-button>
                  </div>
                </div>
              </div>
            }
          </div>
        </form>
        <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus" id="cancel"
                           type="link">Dotatie specificatie toevoegen
        </snelstart-ui-button>
      </div>
      <div class="dialog-right" style="flex: 1 1 0; min-width: 0;">
        <form [formGroup]="formGroup">
          <snelstart-ui-number-form-control label="Reservering openingsbalans"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
                                            align="right"
                                            class="custom-input-250"
                                            formControlName="waardeOpening"
                                            id="bedrag-' + i"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
          <snelstart-ui-number-form-control label="Dotaties conform specificatie"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
                                            align="right"
                                            class="custom-input-250"
                                            formControlName="dotatieEgalisatiereserve"
                                            id="bedrag-' + i"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
          <snelstart-ui-number-form-control label="Berekende vrijval"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
                                            [calculate]="totaalVrijval"
                                            align="right"
                                            class="custom-input-250"
                                            formControlName="vrijvalEgalisatiereserve"
                                            id="bedrag-' + i"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
          <snelstart-ui-number-form-control label="Reservering slotbalans"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
                                            align="right"
                                            class="custom-input-250"
                                            formControlName="waardeSlot"
                                            id="bedrag-' + i"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </form>
      </div>
    </div>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex mt-2">
    <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
    <snelstart-ui-button [disabled]="omschrijvingBedragFg.invalid" icon="check" id="save" type="primary">Opslaan
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
